module.exports = __webpack_public_path__ + "images/98b5ac2ac87c594b6116b765254e525e.svg";